import React, { useState } from 'react';
import logo from '../logo.svg';
import UserProfile from './UserProfile';

const Navigation = ({ currentPage, onNavigate, user, onSignOut, onShowAuth }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  // Navigation items
  const navItems = [
    { name: 'ABOUT US', key: 'about', href: '#' },
    { name: 'RESOURCES', key: 'resources', href: '#' },
    { name: 'CONTACT US', key: 'contact', href: '#' },
  ];

  return (
    <nav className="bg-[#00162C] shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative flex items-center h-16">
          {/* Left Section - Logo */}
          <div className="w-1/4">
            <button
              onClick={() => onNavigate('home')}
              className="flex items-center"
            >
              <img
                src={logo}
                alt="RateIQ Logo"
                className="h-8 w-auto brightness-0 invert"
              />
            </button>
          </div>

          {/* Center Section - Navigation Links (Desktop only) */}
          <div className="hidden md:flex flex-1 justify-center w-1/2">
            <div className="flex items-baseline justify-center space-x-12">
              {navItems.map((item) => (
                <button
                  key={item.key}
                  onClick={() => onNavigate(item.key)}
                  className={`px-3 py-2 text-sm font-medium transition-colors duration-200 ${
                    currentPage === item.key
                      ? 'text-green-400 border-b-2 border-green-400'
                      : 'text-white hover:text-green-400'
                  }`}
                >
                  {item.name}
                </button>
              ))}
            </div>
          </div>

          {/* Desktop Right Section */}
          <div className="hidden md:flex items-center space-x-4">
            {user ? (
              <>
                <button
                  onClick={() => onNavigate('upload')}
                  className="bg-[#DBE46D] hover:bg-[#DBE46D]/90 text-rateiq-darkest-blue font-medium py-2 px-4 rounded-lg transition-colors duration-200"
                >
                  UPLOAD STATEMENT
                </button>
                <UserProfile user={user} onSignOut={onSignOut} />
              </>
            ) : (
              <>
                <button
                  onClick={onShowAuth}
                  className="text-white hover:text-[#DBE46D] font-medium transition-colors duration-200"
                >
                  LOGIN
                </button>
                <button
                  onClick={onShowAuth}
                  className="bg-[#DBE46D] hover:bg-[#DBE46D]/90 text-rateiq-darkest-blue font-medium py-2 px-4 rounded transition-colors duration-200"
                >
                  UPLOAD STATEMENT
                </button>
              </>
            )}
          </div>

          {/* Mobile hamburger button - absolutely positioned to the right */}
          <button
            type="button"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden absolute right-0 bg-white inline-flex items-center justify-center p-2 rounded-md text-rateiq-darkest-blue hover:text-rateiq-dark-blue hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-rateiq-dark-blue"
            aria-controls="mobile-menu"
            aria-expanded={isMobileMenuOpen}
          >
            <span className="sr-only">{isMobileMenuOpen ? 'Close main menu' : 'Open main menu'}</span>
            {isMobileMenuOpen ? (
              <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden" id="mobile-menu">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
            {navItems.map((item) => (
              <button
                key={item.key}
                onClick={() => {
                  onNavigate(item.key);
                  setIsMobileMenuOpen(false);
                }}
                className={`block px-3 py-2 text-base font-medium w-full text-left transition-colors duration-200 ${
                  currentPage === item.key
                    ? 'text-rateiq-primary-teal bg-gray-100'
                    : 'text-rateiq-primary-blue hover:text-rateiq-primary-teal hover:bg-gray-50'
                }`}
              >
                {item.name}
              </button>
            ))}
            {/* Upload and Login Buttons in Mobile Menu */}
            {user ? (
              <>
                <button
                  onClick={() => {
                    onNavigate('upload');
                    setIsMobileMenuOpen(false);
                  }}
                  className="w-full mt-4 bg-[#DBE46D] hover:bg-[#DBE46D]/90 text-rateiq-darkest-blue font-medium py-3 px-6 rounded transition-colors duration-200"
                >
                  UPLOAD STATEMENT
                </button>
                <div className="mt-4 flex justify-center">
                  <UserProfile user={user} onSignOut={onSignOut} />
                </div>
              </>
            ) : (
              <>
                <button
                  onClick={() => {
                    onShowAuth();
                    setIsMobileMenuOpen(false);
                  }}
                  className="w-full mt-4 text-rateiq-darkest-blue hover:text-green-400 font-medium transition-colors duration-200"
                >
                  LOGIN
                </button>
                <button
                  onClick={() => {
                    onShowAuth();
                    setIsMobileMenuOpen(false);
                  }}
                  className="w-full mt-2 bg-[#DBE46D] hover:bg-[#DBE46D]/90 text-rateiq-darkest-blue font-medium py-3 px-6 rounded transition-colors duration-200"
                >
                  UPLOAD STATEMENT
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation; 